import { Tooltip } from '@clickcease/cc-client-components-lib'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import countries from 'i18n-iso-countries'
import React, { useMemo } from 'react'
import ReactCountryFlag from 'react-country-flag'
import { useTranslation } from 'react-i18next'

import { BlockByCountryEntry, NormalizedSummaryData } from '../../../../../hooks/api/BMDataTypes'

import {
  CountriesBreakdownWrapper,
  StyledTable,
  StyledTd,
  NumberCell,
  CountriesBreakdownTitle,
  StyledTh,
  FlagStyles,
  TooltipStyle,
} from './CountriesBreakdown.styled'

interface CountriesBreakdownProps {
  summary: NormalizedSummaryData
}

export const CountriesBreakdown: React.FC<CountriesBreakdownProps> = ({ summary }) => {
  const { t } = useTranslation('botMitigation')

  const blocksByCountry = useMemo<BlockByCountryEntry[]>(() => {
    return summary.rawData?.blocksByCountry?.slice(0, 10) ?? []
  }, [summary.rawData])

  const getCountryName = (code: string) => {
    return countries.getName(code.toUpperCase(), 'en', { select: 'alias' }) || code
  }

  return (
    <CountriesBreakdownWrapper>
      <CountriesBreakdownTitle>
        {t('countriesBreakdown.title')}
        <Tooltip
          tooltiptContent={t('countriesBreakdown.tooltip')}
          constentStyle={{ width: '270px', fontSize: '12px' }}
          side="top"
        >
          <FontAwesomeIcon icon={faInfoCircle as IconProp} style={TooltipStyle} />
        </Tooltip>
      </CountriesBreakdownTitle>
      <StyledTable>
        <thead>
          <tr>
            <StyledTh>{t('countriesBreakdown.country')}</StyledTh>
            <StyledTh>{t('countriesBreakdown.invalidTraffic')}</StyledTh>
            <StyledTh>{t('countriesBreakdown.invalidRate')}</StyledTh>
          </tr>
        </thead>
        <tbody>
          {blocksByCountry.length > 0 ? (
            blocksByCountry.map((country) => (
              <tr key={country.country}>
                <StyledTd title={getCountryName(country.country)}>
                  <ReactCountryFlag countryCode={country.country} svg style={FlagStyles} />
                  {getCountryName(country.country)}
                </StyledTd>
                <NumberCell>{country.totalBlocked.toLocaleString()}</NumberCell>
                <NumberCell>{country.invalidRate.toFixed(2)}%</NumberCell>
              </tr>
            ))
          ) : (
            <tr>
              <StyledTd colSpan={3} style={{ justifyContent: 'center' }}>
                {t('countriesBreakdown.noData')}
              </StyledTd>
            </tr>
          )}
        </tbody>
      </StyledTable>
    </CountriesBreakdownWrapper>
  )
}
